





























































import Vue from 'vue'
import { unix as momunix } from 'moment'

import { DashboardTemplate } from '../base/store/state.interface'
import { DragDropService } from './widgets/base/drag-drop'
import { EventService } from '../base/services/EventService'
import { PermutatorService } from './widgets/base/permutator'
import { Widget, WidgetRow } from './widgets/base'
import { WidgetContainerBreadcrumbService } from './widgets/container/WidgetContainerBreadcrumbService'
import ConfirmDeleteTemplateDialog from './dialogs/ConfirmDeleteTemplateDialog.vue'
import DashboardSettingsDialog from './dialogs/DashboardSettingsDialog.vue'
import ElementTreePanel from './element-tree-panel/ElementTreePanel.vue'
import SaveDashboardDialog from './dialogs/SaveDashboardDialog.vue'
import SelectTemplateDialog from './dialogs/SelectTemplateDialog.vue'
import SettingsPanel from './settings-panel/SettingsPanel.vue'
import WidgetContainer from './widgets/container/WidgetContainer.vue'
import WidgetContainerFactory from './widgets/container/WidgetContainerFactory'
import WidgetPanel from './widget-panel/WidgetPanel.vue'
import { DateTimeService } from '../base/services/DateTimeService'

export default Vue.extend({
  components: {
    ConfirmDeleteTemplateDialog,
    DashboardSettingsDialog,
    ElementTreePanel,
    SaveDashboardDialog,
    SelectTemplateDialog,
    SettingsPanel,
    WidgetContainer,
    WidgetPanel,
  },
  data() {
    return {
      container: WidgetContainerFactory.create(),
      dashboardTemplate: undefined,
      doShowConfirmDeleteDialog: false,
      doShowDashboardSettingsDialog: false,
      doShowSaveDashboardDialog: false,
      doShowSelectTemplateDialog: false,
      indicateRemoval: false,
      initialisedTemplateId: 0,
      isDebugMode: false,
      isEditable: false,
      isEditMode: false,
      isPristine: true,
      onBeforeUnloadCb: null as any,
      timestampTimer: null as any,
      currentTimestamp: DateTimeService.unixTimestamp()
    }
  },
  computed: {
    widgetBoardOuterCssClasses(): object {
      return {
        'indicate-removal': this.indicateRemoval,
        'is-editable': this.isEditable,
      }
    },
    darkMode(): boolean {
      return this.$store.state.app.darkMode
    },
    currentDashboardSettings: {
      set(settings: object): void { this.$store.dispatch('setCurrentDashboardSettings', settings) },
      get(): object | any { return this.$store.state.dashboard.selectedTemplate?.settings || {} }
    },
    timestamp: {
      set(ts: number): void { this.currentTimestamp = ts },
      get(): number { return this.currentTimestamp }
    },
    alarmCountdownExpired(): boolean {
      // Convert minutes to seconds
      const countdownTime = (this.currentDashboardSettings?.operationsDuration * 60)
      const currentAlarmId = this.$store.getters.getCurrentAlarmId
      const currentAlarmTsCreated = this.$store.state.alarm.items[currentAlarmId]?.ts_create

      return (this.timestamp - currentAlarmTsCreated) >= countdownTime
    },
    isAlarmMode(): boolean {
      const alarmItems = this.$store.state.alarm.items
      const hasAlarmData = Object.keys(alarmItems).length > 0
      const allAlarmsClosed = Object.keys(alarmItems).every(key => alarmItems[key].closed)

      const _evaluate = [hasAlarmData, !allAlarmsClosed, !this.isEditable]

      if (this.currentDashboardSettings?.operationsDuration) {
        _evaluate.push(!this.alarmCountdownExpired)
      }

      return _evaluate.every(key => key)
    },
    currentDashboardTemplate(): any {
      return this.$store.state.dashboard?.selectedTemplate
    },
    currentAlarmDashboardTemplate(): object | any {
      const alarmDashboardId = this.$store.state.dashboard?.selectedTemplate?.alarmDashboardId

      if (typeof alarmDashboardId !== 'number' && !alarmDashboardId) return {}

      return ((this.$store.state.dashboard?.templates).filter((elem: any) => elem.id === alarmDashboardId))[0] || {}
    }
  },
  methods: {
    setPristineState(isPristine: boolean) {
      if (this.isDebugMode) {
        isPristine = true
      }
      if (isPristine !== this.isPristine) {
        EventService.$emit('wb-pristine-state-change', isPristine)
      }
      this.isPristine = isPristine
    },
    async setAlarmDashboardId(alarmDashboardId: number) {
      await this.$store.dispatch('setAlarmDashboardTemplate', alarmDashboardId)
    },
    onDuplicateDashboard(dashboard: object | any) {
      this.closeSelectTemplateDialog()
      const template = JSON.parse(JSON.stringify(dashboard))
      delete template.id
      this.dashboardTemplate = template
      this.showSaveDashboardDialog()
    },
    async onDeleteDashboard(dashboard: object | any) {
      this.closeConfirmDeleteDialog()

      if (!dashboard || !dashboard.id) {
        return
      }

      await this.$store.dispatch('deleteDashboardTemplate', dashboard.id)

      Vue.nextTick(() => this.showSelectTemplateDialog())
    },
    closeConfirmDeleteDialog() {
      this.dashboardTemplate = undefined
      this.doShowConfirmDeleteDialog = false
    },
    onConfirmDeleteDashboard(dashboard: object | any) {
      this.closeSelectTemplateDialog()
      this.dashboardTemplate = dashboard
      this.showConfirmDeleteDialog()
    },
    showConfirmDeleteDialog() {
      this.doShowConfirmDeleteDialog = true
    },
    onEditDashboard(dashboard: object | any) {
      this.closeSelectTemplateDialog()
      this.dashboardTemplate = dashboard
      this.showSaveDashboardDialog()
    },
    async onSaveDashboard() {
      this.finishEditMode()
      const dashboard = this.currentDashboardTemplate

      if (!dashboard || !dashboard.id) {
        this.showSaveDashboardDialog()
        return
      }

      await this.$store.dispatch('saveDashboardTemplate', {
        id: dashboard.id,
        settings: this.container.dashboardSettings || {},
        dashboard: PermutatorService.dump(),
        alarmDashboardId: dashboard.alarmDashboardId || null
      })
    },
    async onSaveDashboardAs(dashboardId: number | string, dashboardName: string) {
      // used when duplicating a template
      const dashboardTemplate: DashboardTemplate = this.dashboardTemplate! as DashboardTemplate

      this.closeSaveDashboardDialog()

      if (dashboardId) {
        Vue.nextTick(() => this.showSelectTemplateDialog())
        await this.$store.dispatch('saveDashboardTemplate', {
          id: dashboardId,
          settings: this.container.dashboardSettings,
          title: dashboardName
        })
        return
      }

      await this.$store.dispatch('createDashboardTemplate', {
        title: dashboardName,
        settings: this.container.dashboardSettings,
        dashboard: dashboardTemplate ? dashboardTemplate.dashboard : PermutatorService.dump(),
        alarmDashboardId: null
      })
    },
    showSaveDashboardDialog() {
      this.doShowSaveDashboardDialog = true
    },
    closeSaveDashboardDialog() {
      this.dashboardTemplate = undefined
      this.doShowSaveDashboardDialog = false
    },
    showDashboardSettingsDialog() {
      this.doShowDashboardSettingsDialog = true
    },
    closeDashboardSettingsDialog() {
      this.doShowDashboardSettingsDialog = false
    },
    async onSelectDashboard(template: DashboardTemplate) {
      this.closeSelectTemplateDialog()

      if (!this.isPristine && !confirm(
        'Sie haben ungespeicherte Änderungen in Ihrem Dashboard. ' +
        'Diese gehen verloren, wenn Sie eine Vorlage laden. ' +
        'Möchten Sie wirklich fortfahren ohne zu speichern?'
      )) {
        return
      }

      this.setContainer(JSON.parse(template.dashboard))

      await this.$store.dispatch('selectDashboardTemplate', template)
    },
    closeSelectTemplateDialog() {
      this.doShowSelectTemplateDialog = false
    },
    showSelectTemplateDialog() {
      this.doShowSelectTemplateDialog = true
    },
    prepareEditMode() {
      PermutatorService.prepareAllContainers()
    },
    enterEditMode() {
      if (this.isEditable) return

      this.prepareEditMode()
      this.isEditable = true

      this.$store.dispatch('setNavCustomTemplate', 'widget-board/navigation/editModeNav')

      EventService.$emit('wb-enter-edit-mode', this)
    },
    finishEditMode() {
      this.isEditable = false
      PermutatorService.trimAllRows()
      this.$store.dispatch('setNavCustomTemplate', '')
      EventService.$emit('wb-finish-edit-mode', this)
    },
    cancelEditMode() {
      if (
        !this.isEditable ||
        (
          !this.isPristine && !confirm(
            'Sie haben ungespeicherte Änderungen in Ihrem Dashboard. ' +
            'Diese gehen verloren, wenn Sie den Bearbeitungsmodus beenden. ' +
            'Möchten Sie wirklich fortfahren ohne zu speichern?'
          )
        )
      ) {
        return
      }

      this.setContainer(PermutatorService.getPristineState())
      PermutatorService.trimAllRows()

      this.isEditable = false
      this.setPristineState(true)

      this.$store.dispatch('setNavCustomTemplate', '')

      EventService.$emit('wb-cancel-edit-mode', this)
    },
    setContainer(container: object | any) {
      this.container = container
      this.setPristineState(true)

      PermutatorService.assign(this.container)
      DragDropService.selectContainer(this.container.wbUUID || '')

      if (this.isEditable) {
        this.prepareEditMode()
      }
    },
    onRowDragItemIndicate(row: WidgetRow, widget: Widget, targetIndex: number) {
      PermutatorService.indicateDragDropOperation(row.wbUUID!, widget, targetIndex)
    },
    onRowDragItemLeave(row: WidgetRow, isTemplateWidget: boolean) {
      if (PermutatorService.errorState === 'error-row-not-enough-space') {
        PermutatorService.errorState = ''
        EventService.$emit('success-row-enough-space')
      }

      if (isTemplateWidget) {
        PermutatorService.removeDragDropIndicator(row.wbUUID!)
      }
    },
    onRowDragItemDrop(row: WidgetRow, widget: Widget) {
      PermutatorService.finishDragOperation(row.wbUUID!, widget)
    },
    onDeleteZoneEnter() {
      this.indicateRemoval = true
    },
    onDeleteZoneLeave() {
      this.indicateRemoval = false
    },
    onDeleteZoneDrop() {
      PermutatorService.handleDeleteZoneDrop()
      EventService.$emit('widget-select', null)
      this.indicateRemoval = false
    },
    onWidgetUpdate(widgetUUID: string, widgetProps: any) {
      PermutatorService.updateWidget(widgetUUID, widgetProps)
    },
    onWidgetUpdateSize(widgetUUID: string, targetSize: any) {
      PermutatorService.updateWidget(widgetUUID, { size: targetSize })
    },
    onWidgetUpdateHeight(widgetUUID: string, targetHeight: any) {
      PermutatorService.updateWidget(widgetUUID, { height: targetHeight })
    },
    onDragDropServiceEndDrag() {
      DragDropService.selectContainer(this.container.wbUUID || '')
      PermutatorService.trimAllRows(true)
    },
    onPermutatorServiceContainerUpdate() {
      this.setPristineState(false)
    },
    onBeforeUnload(e: any) {
      if (this.isPristine) {
        return undefined
      }
      e.returnValue = false // Gecko + IE
      return false // Gecko + Webkit, Safari, Chrome etc.
    },
    setCurrentContainer() {
      let template = this.currentDashboardTemplate

      if (this.isAlarmMode && Object.getOwnPropertyNames(this.currentAlarmDashboardTemplate).length > 0) {
        template = this.currentAlarmDashboardTemplate
      }

      let templateLoaded = false

      if (template && Object.keys(template).length !== 0) {
        try {
          this.setContainer(JSON.parse(template.dashboard))
          templateLoaded = true
        } catch (error) {
          console.error('Couldn\'t parse dashboard template', template)
        }
      }

      if (!templateLoaded) this.setContainer(this.container)
    },
    startTimestampTimer() {
      const updateInterval: number = 30

      this.timestampTimer = setInterval(() => {
          this.timestamp = DateTimeService.unixTimestamp()
        }, updateInterval * 1000)
    },
    stopTimestampTimer() {
      if(!this.timestampTimer) return

      clearInterval(this.timestampTimer)
      this.timestampTimer = null
    },
    toggleDarkMode() {
      this.$store.dispatch('setAppDarkMode', !this.darkMode)
    }
  },
  created() {
    EventService.$on('row-drag-item-indicate', this.onRowDragItemIndicate)
    EventService.$on('row-drag-item-leave', this.onRowDragItemLeave)
    EventService.$on('row-drag-item-drop', this.onRowDragItemDrop)

    EventService.$on('delete-zone-enter', this.onDeleteZoneEnter)
    EventService.$on('delete-zone-leave', this.onDeleteZoneLeave)
    EventService.$on('delete-zone-drop', this.onDeleteZoneDrop)

    EventService.$on('widget-update', this.onWidgetUpdate)
    EventService.$on('widget-update-size', this.onWidgetUpdateSize)
    EventService.$on('widget-update-height', this.onWidgetUpdateHeight)

    EventService.$on('drag-drop-service-end-drag', this.onDragDropServiceEndDrag)

    EventService.$on('permutator-service-container-update', this.onPermutatorServiceContainerUpdate)

    // Navigation events
    EventService.$on('wbcmd-entereditmode', this.enterEditMode)
    EventService.$on('wbcmd-savedashboard', this.onSaveDashboard)
    EventService.$on('wbcmd-savedashboardas', this.showSaveDashboardDialog)
    EventService.$on('wbcmd-dashboardsettings', this.showDashboardSettingsDialog)
    EventService.$on('wbcmd-canceleditmode', this.cancelEditMode)
    EventService.$on('wbcmd-selectlayout', this.showSelectTemplateDialog)
    EventService.$on('wbcmd-toggledarkmode', this.toggleDarkMode)

    window.addEventListener('beforeunload', this.onBeforeUnloadCb = this.onBeforeUnload.bind(this))

    this.startTimestampTimer()

    WidgetContainerBreadcrumbService.init()
  },
  mounted() {
    if (this.isDebugMode) {
      Vue.nextTick(() => this.enterEditMode())
    }

    this.setCurrentContainer()

    this.$store.dispatch('setAuxNavTemplate', 'widget-board/navigation/auxNavTemplate')
  },
  destroyed() {
    EventService.$off('row-drag-item-indicate', this.onRowDragItemIndicate)
    EventService.$off('row-drag-item-leave', this.onRowDragItemLeave)
    EventService.$off('row-drag-item-drop', this.onRowDragItemDrop)

    EventService.$off('delete-zone-enter', this.onDeleteZoneEnter)
    EventService.$off('delete-zone-leave', this.onDeleteZoneLeave)
    EventService.$off('delete-zone-drop', this.onDeleteZoneDrop)

    EventService.$off('widget-update', this.onWidgetUpdate)
    EventService.$off('widget-update-size', this.onWidgetUpdateSize)
    EventService.$off('widget-update-height', this.onWidgetUpdateHeight)

    EventService.$off('drag-drop-service-end-drag', this.onDragDropServiceEndDrag)

    EventService.$off('permutator-service-container-update', this.onPermutatorServiceContainerUpdate)

    // Navigation events
    EventService.$off('wbcmd-entereditmode', this.enterEditMode)
    EventService.$off('wbcmd-savedashboard', this.onSaveDashboard)
    EventService.$off('wbcmd-savedashboardas', this.showSaveDashboardDialog)
    EventService.$off('wbcmd-dashboardsettings', this.showDashboardSettingsDialog)
    EventService.$off('wbcmd-canceleditmode', this.cancelEditMode)
    EventService.$off('wbcmd-selectlayout', this.showSelectTemplateDialog)
    EventService.$off('wbcmd-toggledarkmode', this.toggleDarkMode)


    this.stopTimestampTimer()

    if (this.onBeforeUnloadCb) {
      window.removeEventListener('beforeunload', this.onBeforeUnloadCb)
    }

    WidgetContainerBreadcrumbService.destroy()

    this.$store.dispatch('setAuxNavTemplate', '')
    this.$store.dispatch('setNavCustomTemplate', '')
  },
  watch: {
    async container(container) {
      // Legacy compatibility if dashboardSettings object doesn't exists
      if (typeof container.dashboardSettings === 'undefined') {
        container.dashboardSettings = {}
      }

      // Set the dashboardConfig global based on current selected dashboard template
      this.currentDashboardSettings = JSON.parse(this.currentDashboardTemplate.dashboard).dashboardSettings
    },
    isAlarmMode: {
      // Will fire as soon as the component is created
      immediate: true,
      handler(isAlarmMode) {
        this.setCurrentContainer()
      }
    },
    async currentDashboardTemplate(template: DashboardTemplate | undefined) {
      if (template && template.id && (this.initialisedTemplateId !== template.id)) {
        this.initialisedTemplateId = template.id
        await this.$store.dispatch('loadDashboardTemplate', template.id)
        // the store dispatch will trigger a change to "currentDashboardTemplate" so this function will be called
        // again. we exit here and have the template loaded in the 2nd call to not redundantly load it.
        return
      }

      try {
        const dashboard = !template ? WidgetContainerFactory.create() : JSON.parse(template.dashboard)
        this.setContainer(dashboard)
        this.setCurrentContainer()
      } catch (error) {
        // ignore errors
      }
    }
  }
})
